import { Grid, Typography } from "@mui/material";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { CustomVideoSlide } from "components/types/lightBox";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";
import { BuildLighboxSlide } from "views/knowledge/components/card/behaviors/common/CardLightbox";
import { CommentButton, FavoriteButton, LikeButton, ViewMoreButton } from "views/knowledge/components/card/behaviors/common/Interaction";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";
import { publishShortVideoCompletedEvent } from "views/knowledge/components/card/CardEvents";
import { ShortVideoPlayer } from "views/knowledge/shorts/components/ShortVideoPlayer";

///
export const ShortExplorerTitle = () => {
    const { pub } = useCardContext();
    return (
        <Link to={KnowledgePaths.PublicationViewerResolver(pub.publicationId, pub.publicationType, pub.masterPublication?.publicationId)}>
            <MprcFeedTypography variant="title" component="div" noWrap title={pub.title}>
                {pub.title.substring(0, 120)}
            </MprcFeedTypography>
        </Link>
    );
};

///
export const ShortExplorerFooter = () => {
    return (
        <Grid container justifyContent="space-between" alignItems="center">
            <Grid>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                    <Grid>
                        <LikeButton />
                    </Grid>
                    <Grid>
                        <CommentButton />
                    </Grid>
                </Grid>
            </Grid>
            <Grid>
                <FavoriteButton showLabel />
            </Grid>
            <Grid >
                <ViewMoreButton />
            </Grid>
        </Grid>
    );
};

///
export const ShortExplorerContentMedia = () => {
    const { pub: { attachs, shortVideo } } = useCardContext();

    const { t } = useTranslation("knowledge");

    var at = attachs?.find(p => p.attachId == shortVideo?.attachId);
    if (at != null) {
        const slide = BuildLighboxSlide(at, true) as CustomVideoSlide;
        if (slide != null) {
            return (
                <ShortVideoPlayer
                    {...slide}
                    height="calc(100vh - 360px)"
                    editMode={false}
                    startTime={shortVideo?.startTime}
                    endTime={shortVideo?.endTime}
                    onEnded={() => publishShortVideoCompletedEvent()}
                    onProgress={() => { }}
                />
            );
        }
    }

    return <Typography variant="h1" color="error">{t("Feed.Card.Common.ErrorRenderVideoText")}</Typography>;
};
